module.exports = __webpack_public_path__ + "img/filter-type-fullbody.18c06773.svg";